"use client";

import { Globe, ChartLine, MessageCircle, Server, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Desarrollo Web Inteligente",
  description: "Webs premium, escalables y automatizadas para empresas modernas que necesitan sistemas digitales de alto rendimiento.",
  icon: Globe
}, {
  title: "Infraestructura Digital Segura",
  description: "Servidores de nivel empresarial, SSL avanzado y uptime garantizado para sistemas críticos y plataformas comerciales.",
  icon: Server
}, {
  title: "Posicionamiento Digital & Captación Inteligente",
  description: "Sistemas de posicionamiento avanzado, automatización de captación de leads y optimización algorítmica para máxima visibilidad.",
  icon: ChartLine
}, {
  title: "Agentes AI",
  description: "Asistentes comerciales y técnicos con inteligencia artificial para captar clientes, responder consultas y automatizar oportunidades comerciales.",
  icon: Zap
}];
export default function TodoLoQueTuNegocioNecesitaParaCrecerOnline() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll();
  return <section id="todoloquetunegocionecesitaparacreceronline" className="bg-foreground relative overflow-hidden py-24">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-lg blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="text-background/60 uppercase tracking-widest text-sm font-bold mb-4">
            Soluciones digitales inteligentes diseñadas para escalar tu operación
          </p>
          <h2 className="text-background text-4xl md:text-5xl font-extrabold tracking-tight">
            Plataforma Integral de Soluciones Digitales e IA
          </h2>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16 transition-all duration-1000 delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {services.map((service, i) => {
          const cardContent = <Card data-index={i} className="bg-background/5 border-primary/20 backdrop-blur-md rounded-md hover:border-primary/50 transition-all duration-300 hover:shadow-[0_0_30px_-5px_var(--color-primary)] hover:-translate-y-1 group h-full">
                <CardHeader className="pb-4">
                  <div className="size-14 rounded-md bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                    <service.icon className="size-7 text-primary" />
                  </div>
                  <CardTitle className="text-background text-2xl font-bold">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-background/70 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
          if (i === 3) {
            return <Link to="#" key={i} className="block h-full">
                  {cardContent}
                </Link>;
          }
          return <div key={i} className="h-full">{cardContent}</div>;
        })}
        </div>

        <div ref={ctaRef} className={`text-center transition-all duration-700 delay-500 ${isCtaVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-95"}`}>
          <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 rounded-md font-bold px-8 py-6 text-lg hover:shadow-[0_0_30px_-5px_var(--color-secondary)] transition-all">
            <Link to="#listo-para-crecer" onClick={e => {
            e.preventDefault();
            document.getElementById('listo-para-crecer')?.scrollIntoView({
              behavior: 'smooth'
            });
          }}>
              <MessageCircle className="mr-2 size-5" />
              Solicita diagnóstico gratis
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}